<template>
  <div>
    <div class="row flex-wrap">   
      <div class="col-12 col-sm-4">
        <name></name>
      </div>
      <div class="col-12 col-sm-8">
        <big-boxes></big-boxes>
      </div>
      <div class="col-12">
        <core></core>
      </div>
    </div>

    <!--mobile-->
    <div v-if="mobile" class="row"> 
      <div class="col-12">
        <trackables>Trackables</trackables>
        <attributes>Ability Scores</attributes>
        <base-values>Proficiency</base-values>
        <defenses>Defenses</defenses>
        <actions>Actions</actions>
        <spells>Spells</spells>
        <rules section="abilities" single="Ability">Abilities</rules>
        <rules section="feats" single="Feat">Feats</rules>
        <skills>Skills</skills>
        <items>Equipment</items>
        <notes>Notes</notes>
      </div>
    </div>

    <!--full-->
    <div v-else class="row">
      <div class="col-12 col-sm-4">
        <trackables>Trackables</trackables>
        <attributes>Ability Scores</attributes>
        <defenses>Defenses</defenses>
        <items>Equipment</items>
        <notes>Notes</notes>
      </div>
      <div class="col-12 col-sm-5">
        <actions>Actions</actions>
        <spells>Spells</spells>
        <rules section="abilities" single="Ability">Abilities</rules>
        <rules section="feats" single="Feat">Feats</rules>
      </div>
      <div class="col-12 col-sm-3">
        <skills>Skills</skills>
        <base-values>Proficiency</base-values>
      </div>
    </div>
    
  </div>
</template>

<script>
import Actions from "./actions/Index.vue";
import Attributes from "./attributes/Index.vue";
import BaseValues from "./basevalues/Index.vue";
import BigBoxes from "./bigboxes/Index.vue";
import Core from "./core/Index.vue";
import Defenses from "./defenses/Index.vue";
import Items from "./items/Index.vue";
import Name from "./_Name.vue";
import Notes from "./notes/Index.vue";
import Rules from "./rules/Index.vue";
import Skills from "./skills/Index.vue";
import Spells from "./spells/Index.vue";
import Trackables from "./trackables/Index.vue";

export default {
  name: "character-sheet-fifth-edition",
  components: {
    Actions,
    Attributes,
    BaseValues,
    BigBoxes,
    Core,
    Defenses,
    Items,
    Name,
    Notes,
    Rules,
    Skills,
    Spells,
    Trackables
  },
  props: ["item"],
  computed: {
    mobile() {
      let width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      return width < 576;
    }
  }
};
</script>
